/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add"; // Added Import
import RemoveIcon from "@mui/icons-material/Remove"; // Added Import
import React, { useEffect, useMemo, useState, useContext } from "react";
import * as Sentry from "@sentry/react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Modal from "../../../../components/common/Modal/Modal";
import Pagination from "../../../../components/common/new/Pagination/Pagination";
import Typography from "../../../../components/common/new/Typography/Typography";
import { Constants, AlertStatus, PERMISSIONS } from "../../../../contants";
import {
  APPOINTMENT_COL,
  ATTENDANCE_COL,
  FAMILY_COL,
  SUBSCRIPTION_COL,
  INPROGRESS_APPOINTMENT_COL,
  PREVIOUS_APPOINTMENT_COL,
  PREVIOUS_APPOINTMENT_EXPAND_COL,
  AWARDS_COL,
  SPECIAL_GROUP_COL,
  HDC_COL,
  APPOINTMENT_EXPAND_COL,
} from "../../../../contants/table/member";
import Member from "../../../../services/api/member";
import { performOperation } from "../../MemberSearch/utils";
import {
  FLEX_CONTAINER,
  MAX_SIZE,
  ROW_LIMIT,
  TABLE_TYPE,
  getAppointmentRows,
  getAttendanceRows,
  getFamilyMemberRows,
  getFormattedAppointments,
  getFormattedAllPreviousAppointments,
  getFormattedData,
  getFormattedMembers,
  getMaxRow,
  getGohonzonMemberRows,
  getFormattedGohonzon,
  getPreviousAppointmentRows,
  getInprogressAppointmentRows,
  getFormattedSubscription,
  getAllPreviousAppointmentRows,
  ATTENDANCE_MAX_SIZE,
  getAllFamilyMemberRows,
  getExamRows,
  getAwardRows,
  getFormattedExam,
  getFormattedAward,
  getSpecialGroupRows,
  getFormattedSpecial,
  getHdcRows,
  getFormattedHdc,
  getAllAppointmentRows,
  getSubscriptionRows,
} from "../utlis";
import styles from "./Dashboard.styles";
import { ROUTES } from "../../../../utils/constants";
import NewTable from "../../components/Newtable/NewTable";
import Comment from "../../../../assets/svg/Comment";
import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";
import Button from "../../../../components/common/Button";
import Family from "../../../../services/api/Family";
import Loader from "../../../../components/common/Loader/Loader";
import DirectEntryModal from "../../../gohonzon/DirectEntry/DirectEntryModal";
import EditSubscription from "../Components/EditSubscription";
import DirectExamEntryModal from "../Components/DirectExamEntry/DirectExamEntryModal";
import useUserConfig from "../../../../hooks/useUserConfig";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import UpdateDirectExamEntryModal from "../Components/DirectExamEntry/UpdateDirectExamEntryModal";
import GohonzonUpdateModal from "../../../gohonzon/DirectEntry/GohonzonUpdateModal";
import GohonzonDeleteModel from "../../../gohonzon/DirectEntry/GohonzonDeleteModel";
import { selectAllSIUsers } from "../../../../redux/selectors/user";
import AwardsModal from "../Components/Awards/AwardsModal";

const MEETING_TYPE = [
  { value: "discussionMeeting", key: "Discussion Meeting" },
  { value: "goshoMeeting", key: "Gosho Meeting" },
  { value: "NHRMeeting", key: "NHR Meeting" },
  { value: "cubMeeting", key: "Cub Meeting" },
  { value: "YPMeeting", key: "Young Pheonix Meeting" },
  { value: "YLMeeting", key: "Young Lion Meeting" },
  { value: "SDMeeting", key: "Student Meeting" },
];

/* ── Design tokens ──────────────────────────────────────────────────── */
const BG = "#F0F4FA";
const WHITE = "#FFFFFF";
const SHADOW = "0 2px 12px rgba(60,80,120,0.08)";
const RADIUS = "16px";
const TITLE = "#1A2B4A";
const MUTED = "#8A9BB0";
const BORDER = "#EDF2FB";

/* Exam icon colours per index */
const EXAM_PALETTE = [
  { bg: "#EEF2FF", icon: "#4F46E5", emoji: "📖" },
  { bg: "#FEF9C3", icon: "#CA8A04", emoji: "✏️" },
  { bg: "#DCFCE7", icon: "#16A34A", emoji: "🎓" },
  { bg: "#FFE4E6", icon: "#DC2626", emoji: "⭐" },
];

/* Appointment dot colours */
const apptDot = (item) => {
  const end = item?.toDate || item?.endDate || "";
  const type = (
    item?.mainline ||
    item?.mainLine ||
    item?.membershipType ||
    item?.appointmentType ||
    ""
  ).toLowerCase();
  if (!end || end === "Present") return "#22C55E";
  if (type.includes("dual")) return "#F59E0B";
  return "#3B82F6";
};
/* ──────────────────────────────────────────────────────────────────────────────────
AppointmentTimeline
────────────────────────────────────────────────────────────────────────────────── */
const getShortSubDivisionName = (name) => {
  if (!name) return name;

  return name
    .replace(/\s+(Boys|Girls)\s*\(.*?\)$/i, "")
    .replace(/\s+(Boys|Girls)$/i, "")
    .trim();
};
function AppointmentTimeline({ current = [], previous = [], memberInfo }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const allItems = [
    ...(current || []).map((i) => ({ ...i, _isCurrent: true })),
    ...(previous || []).map((i) => ({ ...i, _isCurrent: false })),
  ];

  if (allItems.length === 0) {
    return (
      <Box
        sx={{
          p: "24px",
          textAlign: "center",
          color: "#94A3B8",
          fontSize: "13px",
        }}
      >
        No appointment history available.
      </Box>
    );
  }

  const visibleItems = isExpanded ? allItems : allItems.slice(0, 5);
  const showToggle = allItems.length > 5;

  return (
    <Box sx={{ p: "20px", display: "flex", flexDirection: "column" }}>
      {visibleItems.map((item, index) => {
        console.log("appt item =>", item);
        const isLast = index === visibleItems.length - 1;

        const pos =
          item?.position || item?.appliedForName || item?.positionName || "";
        const div =
          item?.divisionName ||
          item?.division ||
          item?.divisionDetails?.divisionName ||
          item?.divisionDetails?.name ||
          "";
        const shortSubDivision = getShortSubDivisionName(
          item?.subdivisionName || item?.subDivisionName
        );
        const divWithSubDivision = [div, shortSubDivision]
          .filter(Boolean)
          .join(" / ");
        const loc =
          item?.location || item?.locationName || item?.districtName || "";

        const hierarchy = item?._isCurrent
          ? [
              memberInfo?.areaName,
              memberInfo?.clusterName,
              memberInfo?.zoneName,
              memberInfo?.regionName,
              memberInfo?.chapterName,
              memberInfo?.districtName,
              memberInfo?.blockName,
            ]
              .filter(Boolean)
              .join(" / ")
          : item?.orgStructure ||
            item?.organizationStructure ||
            [
              item?.zoneName,
              item?.clusterName,
              item?.areaName,
              item?.regionName,
              item?.chapterName,
              item?.districtName,
              item?.subDivisionName,
            ]
              .filter(Boolean)
              .join(" / ");

        const mainLineText = [pos, divWithSubDivision, loc]
          .filter(Boolean)
          .join(", ");

        const startDate =
          item?.appointmentDate || item?.appointmentFromDate || item?.createdAt;

        const endDate =
          item?.appointmentToDate ||
          item?.deactivatedAt ||
          item?.toDate ||
          item?.endDate ||
          "";

        let dateDisplay = startDate || "";
        if (endDate) {
          dateDisplay += ` - ${endDate}`;
        } else if (item._isCurrent) {
          dateDisplay += " - Present";
        }

        const year = startDate
          ? String(startDate).split(/[-/.]/)[2] ||
            String(startDate).split(/[-/.]/)[0]
          : "";

        const reason = item?.remark || item?.reason || "";
        const type = item?.mainline || item?.mainLine || "Mainline";

        const dotColor = (() => {
          if (type.includes("dual")) return "#F59E0B";
          if (item._isCurrent) return "#22C55E";
          return "#94A3B8";
        })();

        return (
          <Box key={index} sx={{ display: "flex", minHeight: "90px" }}>
            <Box
              sx={{
                width: "45px",
                textAlign: "right",
                pt: "2px",
                pr: "12px",
                flexShrink: 0,
              }}
            >
              <Typography
                style={{ fontSize: "12px", fontWeight: 700, color: "#1A2B4A" }}
              >
                {year}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mr: "16px",
                flexShrink: 0,
              }}
            >
              <Box
                sx={{
                  width: "14px",
                  height: "14px",
                  borderRadius: "50%",
                  background: "#fff",
                  border: `3px solid ${dotColor}`,
                  zIndex: 2,
                  flexShrink: 0,
                }}
              />
              {!isLast && (
                <Box
                  sx={{
                    width: "2px",
                    flex: 1,
                    background: "#E2E8F0",
                    my: "2px",
                  }}
                />
              )}
            </Box>

            <Box sx={{ pb: "28px", flex: 1, minWidth: 0 }}>
              <Typography
                style={{
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "#1A2B4A",
                  marginBottom: "4px",
                  lineHeight: 1.3,
                }}
              >
                {mainLineText}
              </Typography>

              {hierarchy && (
                <Typography
                  style={{
                    fontSize: "13px",
                    color: "#475569",
                    marginBottom: "4px",
                    lineHeight: 1.4,
                    display: "flex",
                  }}
                >
                  {hierarchy}
                </Typography>
              )}

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  style={{
                    fontSize: "11px",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    color: type.toLowerCase().includes("dual")
                      ? "#D97706"
                      : "#2563EB",
                  }}
                >
                  {type}
                </Typography>
                <Typography style={{ fontSize: "11px", color: "#94A3B8" }}>
                  •
                </Typography>
                <Typography style={{ fontSize: "11px", color: "#64748B" }}>
                  {dateDisplay}
                </Typography>
              </Box>

              {reason && (
                <Typography
                  style={{
                    fontSize: "12px",
                    color: "#64748B",
                    marginTop: "2px",
                    fontStyle: "italic",
                  }}
                >
                  Reason: {reason}
                </Typography>
              )}
            </Box>
          </Box>
        );
      })}

      {showToggle && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: "12px" }}>
          <Box
            onClick={() => setIsExpanded(!isExpanded)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              padding: "6px 16px",
              borderRadius: "20px",
              background: "#F8FAFC",
              border: "1px solid #E2E8F0",
              transition: "background 0.2s",
              "&:hover": { background: "#F1F5F9" },
            }}
          >
            {isExpanded ? (
              <>
                <RemoveIcon sx={{ fontSize: "16px", color: "#475569" }} />
                <Typography
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#475569",
                  }}
                >
                  See Less
                </Typography>
              </>
            ) : (
              <>
                <AddIcon sx={{ fontSize: "16px", color: "#475569" }} />
                <Typography
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#475569",
                  }}
                >
                  See More Appointment History
                </Typography>
              </>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
}

/* ── White card shell ─────────────────────────────────────────────────── */
function Card({ title, subtitle, headerRight, children, style }) {
  return (
    <Box
      sx={{
        background: WHITE,
        borderRadius: RADIUS,
        boxShadow: SHADOW,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        ...style,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: "18px",
          pt: "14px",
          pb: "11px",
          borderBottom: `1px solid ${BORDER}`,
          flexShrink: 0,
        }}
      >
        <Box>
          <Typography
            component="p"
            weight={700}
            style={{ color: TITLE, fontSize: "15px", lineHeight: "1.3" }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              style={{ color: MUTED, fontSize: "11px", marginTop: "2px" }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {headerRight}
        </Box>
      </Box>
      {children}
    </Box>
  );
}

/* ── Small action pill ────────────────────────────────────────────────── */
function Pill({ label, color = "#2563EB", bg = "#EFF6FF", onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        fontSize: "11px",
        fontWeight: 600,
        color,
        background: bg,
        borderRadius: "6px",
        px: "8px",
        py: "4px",
        cursor: "pointer",
        "&:hover": { opacity: 0.8 },
      }}
    >
      {label}
    </Box>
  );
}

/* ── Table head style helper ──────────────────────────────────────────── */
const headStyle = (bg = "#EDF2FB", color = "#3D5A80") => ({
  padding: "9px 14px",
  color,
  fontWeight: 700,
  background: bg,
  fontSize: "12px",
});

/* ─────────────────────────────────────────────────────────────────────
   EXAM ICON CARD LIST
──────────────────────────────────────────────────────────────────────── */
function ExamIconList({
  data,
  hasPermission,
  onDelete,
  onEdit,
  canManageCrud,
}) {
  if (!data || data.length === 0)
    return (
      <Box sx={{ p: "16px 18px", textAlign: "center" }}>
        <Typography style={{ color: MUTED, fontSize: "13px" }}>
          No data available
        </Typography>
      </Box>
    );

  const canDelete =
    canManageCrud &&
    hasPermission(PERMISSIONS.REMOVE_EXAMINATION_APPLIED_MEMBERS);
  const canEdit =
    canManageCrud &&
    hasPermission(PERMISSIONS.UPDATE_EXAMINATION_APPLIED_MEMBERS);

  return (
    <Box
      sx={{
        px: "14px",
        py: "10px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      {data.map((item, i) => {
        const pal = EXAM_PALETTE[i % EXAM_PALETTE.length];
        const label = item?.exam || item?.examName || item?.examLevel || "-";

        let dateStr = "";

        if (item?.examDate) {
          const d = new Date(item.examDate);
          const monthName = d.toLocaleString("en-IN", { month: "long" });
          const year = d.getFullYear();
          dateStr = `${monthName}, ${year}`;
        }

        return (
          <Box
            key={i}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              px: "12px",
              py: "10px",
              borderRadius: "10px",
              background: "#F8FAFD",
              transition: "background 0.15s",
              "&:hover": { background: "#EDF2FB" },
            }}
          >
            <Box
              sx={{
                width: "36px",
                height: "36px",
                borderRadius: "10px",
                background: pal.bg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "17px",
                flexShrink: 0,
              }}
            >
              {pal.emoji}
            </Box>

            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                style={{ fontSize: "13px", fontWeight: 600, color: TITLE }}
              >
                {label}
              </Typography>
              {dateStr && (
                <Typography
                  style={{ fontSize: "11px", color: MUTED, marginTop: "1px" }}
                >
                  {dateStr}
                </Typography>
              )}
            </Box>

            <Box sx={{ display: "flex", gap: "4px", flexShrink: 0 }}>
              {canEdit && (
                <Box
                  onClick={() => onEdit(item)}
                  sx={{
                    p: "4px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    color: "#2563EB",
                    background: "#EFF6FF",
                    display: "flex",
                    alignItems: "center",
                    "&:hover": { background: "#DBEAFE" },
                  }}
                >
                  <EditIcon sx={{ fontSize: "15px" }} />
                </Box>
              )}
              {canDelete && (
                <Box
                  onClick={() => onDelete(item)}
                  sx={{
                    p: "4px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    color: "#DC2626",
                    background: "#FEF2F2",
                    display: "flex",
                    alignItems: "center",
                    "&:hover": { background: "#FEE2E2" },
                  }}
                >
                  <DeleteOutlineIcon sx={{ fontSize: "15px" }} />
                </Box>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

function TimelineSection({ label, dotColor, accentBg, accentText, tableNode }) {
  return (
    <Box sx={{ display: "flex", gap: 0 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pl: "16px",
          pr: "10px",
          pt: "14px",
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            width: "12px",
            height: "12px",
            borderRadius: "50%",
            background: dotColor,
            border: "2px solid #fff",
            boxShadow: `0 0 0 2px ${dotColor}40`,
            flexShrink: 0,
            zIndex: 1,
          }}
        />
        <Box sx={{ width: "2px", flex: 1, background: BORDER, mt: "4px" }} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0, pb: "4px" }}>
        <Box sx={{ px: "4px", pt: "12px", pb: "6px" }}>
          <Box
            sx={{
              display: "inline-block",
              fontSize: "10px",
              fontWeight: 700,
              color: accentText,
              background: accentBg,
              borderRadius: "20px",
              px: "10px",
              py: "2px",
              textTransform: "uppercase",
              letterSpacing: "0.4px",
            }}
          >
            {label}
          </Box>
        </Box>
        {tableNode}
      </Box>
    </Box>
  );
}

function MeetingPanel({ meeting }) {
  const rows = Array.isArray(meeting?.rows) ? meeting?.rows : [];

  const getDisplayDate = (row) => {
    const month = row?.month || row?.Month || row?.monthName;
    const year = row?.year || row?.Year || row?.yearName;

    if (month && year) return `${month}, ${year}`;

    if (row?.date) {
      const d = new Date(row.date);
      if (!Number.isNaN(d.getTime()))
        return d.toLocaleString("en-US", { month: "long", year: "numeric" });
    }
    return "-";
  };

  return (
    <Box
      sx={{
        flex: "1 1 0",
        minWidth: 0,
        background: WHITE,
        borderRadius: "8px",
        border: `1px solid ${BORDER}`,
        boxShadow: "none",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: "20px",
          pt: "20px",
          pb: "16px",
        }}
      >
        <Typography style={{ fontSize: "16px", fontWeight: 700, color: TITLE }}>
          {meeting?.title}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: "20px",
          pb: "12px",
          borderBottom: `1px solid ${BORDER}`,
        }}
      >
        <Typography
          style={{
            width: "45px",
            fontSize: "13px",
            fontWeight: 700,
            color: TITLE,
          }}
        >
          #
        </Typography>
        <Typography
          style={{ flex: 1, fontSize: "13px", fontWeight: 700, color: TITLE }}
        >
          Month, Year
        </Typography>
      </Box>

      <Box sx={{ px: "20px", pb: "10px" }}>
        {rows.length > 0 ? (
          rows.map((row, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                py: "14px",
                borderBottom: `1px solid ${BORDER}`,
              }}
            >
              <Typography
                style={{
                  width: "45px",
                  fontSize: "13px",
                  fontWeight: 700,
                  color: TITLE,
                }}
              >
                {index + 1}
              </Typography>

              <Typography
                style={{ flex: 1, fontSize: "13px", color: "#475569" }}
              >
                {getDisplayDate(row)}
              </Typography>
            </Box>
          ))
        ) : (
          <Box sx={{ py: "20px", textAlign: "center" }}>
            <Typography style={{ fontSize: "13px", color: MUTED }}>
              No records found
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}

const getApi = (tableType) => {
  switch (tableType) {
    case TABLE_TYPE.FAMILY:
      return Family.getFamilyDetailsByMemberId;
    case TABLE_TYPE.APPOINTMENT:
      return Member.getCurrentAppointmentsByMemberId;
    case TABLE_TYPE.ATTENDANCE:
      return Member.getAttendanceByMemberId;
    case TABLE_TYPE.GOHONZON:
      return Member.getMemberDetailsById;
    case TABLE_TYPE.PREVIOUSAPPOINTMENT:
      return Member.getAppointmentsByMemberId;
    case TABLE_TYPE.INPROGRESSAPPOINTMENT:
      return Member.getMemberDetailsById;
    case TABLE_TYPE.EXAMINATION:
      return Member.getExamByMemberId;
    case TABLE_TYPE.SUBS:
      return Member.getSubscriptionByMemberId;
    case TABLE_TYPE.AWARDS:
      return Member.getAwardByMemberId;
    case TABLE_TYPE.SPECIAL:
      return Member.getMemberDetailsById;
    case TABLE_TYPE.HDC:
      return Member.getMemberDetailsById;
    default:
      return null;
  }
};

const getBeautifyData = (data, t) => {
  if (t === TABLE_TYPE.APPOINTMENT) return getFormattedAppointments(data);
  if (t === TABLE_TYPE.PREVIOUSAPPOINTMENT)
    return getFormattedAllPreviousAppointments(data);
  if (t === TABLE_TYPE.ATTENDANCE) return getFormattedData(data);
  if (t === TABLE_TYPE.GOHONZON) return getFormattedGohonzon(data);
  if (t === TABLE_TYPE.SUBS) return getFormattedSubscription(data);
  if (t === TABLE_TYPE.EXAMINATION) return getFormattedExam(data);
  if (t === TABLE_TYPE.AWARDS) return getFormattedAward(data);
  if (t === TABLE_TYPE.SPECIAL) return getFormattedSpecial(data);
  if (t === TABLE_TYPE.HDC) return getFormattedHdc(data);
  return getFormattedMembers(data);
};

function Alert({ open, onClose, onSubmit, selectedMember }) {
  const handleSubmit = () => {
    onSubmit(selectedMember);
    onClose();
  };
  return (
    <Modal open={open} onClose={onClose}>
      <Typography
        style={{
          fontSize: "18px",
          fontWeight: "600",
          paddingBottom: "16px",
          color: TITLE,
        }}
      >
        Are you sure you want to
        <br />
        delete this entry?
      </Typography>
      <Box style={{ paddingTop: "40px", display: "flex", gap: "12px" }}>
        <Button
          onClick={handleSubmit}
          label="Yes"
          style={{ marginRight: "10px" }}
        />
        <Button onClick={onClose} label="No" variant="outlined" />
      </Box>
    </Modal>
  );
}

function ModalContent({
  memberId,
  modalTitle,
  selectedTable,
  subTitle,
  meetingType,
  meetingType1,
  meetingType2,
  onRefresh,
  onClose,
  canManageCrud,
}) {
  const [tableData, setTableData] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState({});
  const [familyTableData, setFamilyTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const hasPermission = useUserConfig();
  const toast = useContext(ToastAlertContext);
  const [updateExamEntryModal, setUpdateExamEntryModal] = useState(false);
  const [selectedExam, setSelectedExam] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [application, setSelectedApplication] = useState(null);
  const [gohonzonUpdateModal, setGohonzonUpdateModal] = useState(false);
  const [gohonzonDeleteModal, setGohonzonDeleteModel] = useState(false);

  const toggleUpdateExamEntry = (exam = null) => {
    setSelectedExam(exam);
    setUpdateExamEntryModal((p) => !p);
  };
  const toggleGohonzonUpdate = (app = null) => {
    setSelectedApplication(app);
    setGohonzonUpdateModal((p) => !p);
  };
  const toggleGohonzonDelete = (app = null) => {
    setSelectedApplication(app);
    setGohonzonDeleteModel((p) => !p);
  };

  const EXAMINATION_COL = [
    { displayName: "Exam Name", key: "exam" },
    { displayName: "Exam Month", key: "examMonth" },
    { displayName: "Exam Year", key: "examYear" },
    ...(canManageCrud &&
    (hasPermission(PERMISSIONS.REMOVE_EXAMINATION_APPLIED_MEMBERS) ||
      hasPermission(PERMISSIONS.UPDATE_EXAMINATION_APPLIED_MEMBERS))
      ? [{ displayName: "Action", key: "action" }]
      : []),
  ];

  const GOHONZON_COL = [
    { displayName: "Type", key: "gohonzonType" },
    { displayName: "Conferred Date", key: "conferralDate" },
    ...(canManageCrud && hasPermission(PERMISSIONS.UPDATE_GOHONZON_APPLICATION)
      ? [{ displayName: "Action", key: "action" }]
      : []),
  ];

  const onDeleteClick = async () => {
    try {
      const payload = {
        examDate: selectedMember.examDate,
        examLevel: selectedMember.examLevel?.toUpperCase(),
        rollNumber: selectedMember.rollNumber,
        remark: selectedMember.remark,
      };
      await Member.removeExam({
        // applicationId: selectedMember.applicationId,
        applicationId: selectedMember.examId || selectedMember.applicationId,
        // memberId: selectedMember.memberId,
        memberId: selectedMember.memberId || memberId,
        data: payload,
      });
      toast.show(`Entry Removed Successfully`, AlertStatus.SUCCESS);
      setTimeout(() => {
        window.location.reload();
        onRefresh();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const content = useMemo(() => {
    const handleDelete = (m) => {
      setSelectedMember(m);
      setOpenAlert(true);
    };
    const onEdit = (e) => toggleUpdateExamEntry(e);

    if (selectedTable === TABLE_TYPE.APPOINTMENT)
      return {
        rows: getAllAppointmentRows(tableData, MAX_SIZE, paginationInfo),
        columns: APPOINTMENT_EXPAND_COL,
      };
    if (selectedTable === TABLE_TYPE.PREVIOUSAPPOINTMENT)
      return {
        rows: getAllPreviousAppointmentRows(
          tableData,
          MAX_SIZE,
          paginationInfo
        ),
        columns: PREVIOUS_APPOINTMENT_EXPAND_COL,
      };
    if (selectedTable === TABLE_TYPE.INPROGRESSAPPOINTMENT)
      return {
        rows: getInprogressAppointmentRows(
          familyTableData,
          tableData,
          MAX_SIZE
        ),
        columns: INPROGRESS_APPOINTMENT_COL,
      };
    if (selectedTable === TABLE_TYPE.FAMILY)
      return {
        rows: getAllFamilyMemberRows(familyTableData, MAX_SIZE),
        columns: FAMILY_COL,
      };
    if (selectedTable === TABLE_TYPE.GOHONZON)
      return {
        rows: getGohonzonMemberRows(
          tableData,
          hasPermission,
          canManageCrud,
          canManageCrud,
          toggleGohonzonUpdate,
          toggleGohonzonDelete,
          MAX_SIZE
        ),
        columns: GOHONZON_COL,
      };
    if (selectedTable === TABLE_TYPE.SUBS)
      return {
        rows: getSubscriptionRows(tableData, MAX_SIZE),
        columns: SUBSCRIPTION_COL,
      };
    if (selectedTable === TABLE_TYPE.EXAMINATION)
      return {
        rows: getExamRows(
          tableData,
          (permission) => canManageCrud && hasPermission(permission),
          handleDelete,
          onEdit,
          MAX_SIZE
        ),
        columns: EXAMINATION_COL,
      };
    if (selectedTable === TABLE_TYPE.AWARDS)
      return { rows: getAwardRows(tableData, MAX_SIZE), columns: AWARDS_COL };
    if (selectedTable === TABLE_TYPE.ATTENDANCE)
      return {
        rows: getAttendanceRows(tableData, ATTENDANCE_MAX_SIZE),
        columns: ATTENDANCE_COL,
      };
    if (selectedTable === TABLE_TYPE.SPECIAL)
      return {
        rows: getSpecialGroupRows(tableData, MAX_SIZE),
        columns: SPECIAL_GROUP_COL,
      };
    if (selectedTable === TABLE_TYPE.HDC)
      return { rows: getHdcRows(tableData, MAX_SIZE), columns: HDC_COL };
    return { rows: [], columns: SUBSCRIPTION_COL };
  }, [tableData, selectedTable, paginationInfo, canManageCrud]);

  const fetchTableData = async (
    tableKey,
    page = 0,
    size = Constants.DEFAULT_PAGE_SIZE
  ) => {
    try {
      setIsLoading(true);
      const { data } = await getApi(tableKey)(memberId, { page, size });
      setTableData(
        getBeautifyData(
          data.data ?? data.content ?? data.inductionSpecialGroups ?? data,
          tableKey
        )
      );
      setFamilyTableData(getFormattedMembers(data?.familyMembers, tableKey));
      setPaginationInfo({
        currentPage: Number(data.number),
        totalPages: Number(data.totalPages),
        totalElements: Number(data.totalElements),
        pageSize: Number(data.size),
      });
      setIsLoading(false);
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };

  const onPaginationClick = (page) =>
    fetchTableData(selectedTable, page, paginationInfo.pageSize);
  const onPageSizeClick = (operator) =>
    fetchTableData(
      selectedTable,
      0,
      performOperation(
        paginationInfo.pageSize,
        Constants.DEFAULT_PAGE_SIZE,
        operator
      )
    );

  useEffect(() => {
    if (selectedTable) fetchTableData(selectedTable);
  }, [selectedTable]);

  const getMeeting = (type) => {
    if (type === "goshoMeeting") return tableData.goshoMeeting;
    if (type === "NHRMeeting") return tableData.NHRMeeting;
    if (type === "cubMeeting") return tableData.cubMeeting;
    if (type === "SDMeeting") return tableData.SDMeeting;
    if (type === "YPMeeting") return tableData.YPMeeting;
    if (type === "YLMeeting") return tableData.YLMeeting;
    return tableData.discussionMeeting;
  };

  return (
    <>
      {isLoading && <Loader />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: "16px",
        }}
      >
        <Typography component="p" weight={700} fontSize="16px" color={TITLE}>
          {modalTitle || subTitle}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            background: "#F0F4FA",
            borderRadius: "8px",
            "&:hover": { background: "#E2E8F0" },
          }}
        >
          <CloseIcon sx={{ fontSize: "18px", color: "#5C7A9B" }} />
        </IconButton>
      </Box>

      {FLEX_CONTAINER.includes(selectedTable) ? (
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            flexWrap: { xs: "wrap", md: "nowrap" },
          }}
        >
          <MeetingPanel meeting={getMeeting(meetingType)} />
          <MeetingPanel meeting={getMeeting(meetingType1)} />
          <MeetingPanel meeting={getMeeting(meetingType2)} />
        </Box>
      ) : (
        <Box
          sx={{
            borderRadius: "12px",
            overflow: "hidden",
            border: `1px solid ${BORDER}`,
          }}
        >
          <NewTable
            columns={content.columns}
            columnCellStyle={{ padding: "8px" }}
            headCellStyle={{ fontSize: 12 }}
            rows={content.rows}
            tableHeadCellStyle={{ ...headStyle(), height: "44px" }}
            scrollable
            tableBodyTheme="#FAFBFE"
          />
        </Box>
      )}

      <Box display="flex" justifyContent="center" mt={3}>
        {![
          TABLE_TYPE.FAMILY,
          TABLE_TYPE.SPECIAL,
          TABLE_TYPE.EXAMINATION,
          TABLE_TYPE.AWARDS,
          TABLE_TYPE.GOHONZON,
          TABLE_TYPE.SUBS,
        ].includes(selectedTable) && (
          <Pagination
            totalPages={paginationInfo.totalPages}
            totalResults={paginationInfo.totalElements}
            currentPage={paginationInfo.currentPage}
            pageSize={paginationInfo.pageSize}
            onChange={onPaginationClick}
            onPageSizeClick={onPageSizeClick}
          />
        )}
      </Box>

      <UpdateDirectExamEntryModal
        open={updateExamEntryModal}
        onClose={() => toggleUpdateExamEntry()}
        exam={selectedExam}
        onRefresh={onRefresh}
      />
      <Alert
        open={openAlert}
        onClose={() => setOpenAlert(false)}
        onSubmit={onDeleteClick}
        selectedMember={selectedMember}
      />
      <GohonzonUpdateModal
        open={gohonzonUpdateModal}
        onClose={() => toggleGohonzonUpdate()}
        application={application}
        onRefresh={onRefresh}
      />
      <GohonzonDeleteModel
        open={gohonzonDeleteModal}
        onClose={() => toggleGohonzonDelete()}
        application={application}
        onRefresh={onRefresh}
      />
    </>
  );
}

/* ══════════════════════════════════════════════════════════════════════
   MAIN DASHBOARD
══════════════════════════════════════════════════════════════════════ */
function Dashboard({
  memberId,
  familyMemberInfo,
  attendanceInfo,
  appointmentInfo,
  memberInfo,
  gohonzonMemberInfo,
  previousAppointmentInfo,
  subscriptionMemberInfo,
  inProgressAppointmentInfo,
  examMemberInfo,
  awardMemberInfo,
  specialMemberInfo,
  hdcInfo,
  onRefresh,
}) {
  const {
    remark,
    districtId,
    regionId,
    areaId,
    clusterId,
    zoneId,
    chapterId,
    subdivisionId,
  } = memberInfo;

  const [openModal, setOpenModal] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [modalSubTitle, setModalSubTitle] = useState("");
  const [meetingType, setMeetingType] = useState(
    subdivisionId !== null ? "cubMeeting" : "discussionMeeting"
  );
  const [meetingType1, setMeetingType1] = useState(
    subdivisionId !== null ? "YPMeeting" : "goshoMeeting"
  );
  const [meetingType2, setMeetingType2] = useState(
    subdivisionId !== null ? "YLMeeting" : "SDMeeting"
  );
  const { isHelpDesk, isHelpDeskAdmin } = useSelector(selectAllSIUsers);
  const canManageCrud = isHelpDesk || isHelpDeskAdmin;

  useEffect(() => {
    if (subdivisionId !== null) {
      setMeetingType("cubMeeting");
      setMeetingType1("YPMeeting");
      setMeetingType2("YLMeeting");
    } else {
      setMeetingType("discussionMeeting");
      setMeetingType1("goshoMeeting");
      setMeetingType2("SDMeeting");
    }
  }, [subdivisionId]);

  const [directEntryModal, setDirectEntryModal] = useState(false);
  const [editSubscription, setEditSubscription] = useState(false);
  const [directExamEntryModal, setDirectExamEntryModal] = useState(false);
  const [awardsModal, setAwardsModal] = useState(false);
  const [updateExamEntryModal, setUpdateExamEntryModal] = useState(false);
  const [selectedExam, setSelectedExam] = useState(null);
  const [application, setSelectedApplication] = useState(null);
  const [gohonzonUpdateModal, setGohonzonUpdateModal] = useState(false);
  const [gohonzonDeleteModal, setGohonzonDeleteModel] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const hasPermission = useUserConfig();
  const toast = useContext(ToastAlertContext);
  const navigate = useNavigate();

  const EXAMINATION_COL = [
    { displayName: "Exam Name", key: "exam" },
    { displayName: "Exam Month", key: "examMonth" },
    { displayName: "Exam Year", key: "examYear" },
    ...(canManageCrud &&
    (hasPermission(PERMISSIONS.REMOVE_EXAMINATION_APPLIED_MEMBERS) ||
      hasPermission(PERMISSIONS.UPDATE_EXAMINATION_APPLIED_MEMBERS))
      ? [{ displayName: "Action", key: "action" }]
      : []),
  ];

  const GOHONZON_COL = [
    { displayName: "Type", key: "gohonzonType" },
    { displayName: "Conferred Date", key: "conferralDate" },
    ...(canManageCrud && hasPermission(PERMISSIONS.UPDATE_GOHONZON_APPLICATION)
      ? [{ displayName: "Action", key: "action" }]
      : []),
  ];

  const toggleGohonzonUpdate = (app = null) => {
    setSelectedApplication(app);
    setGohonzonUpdateModal((p) => !p);
  };
  const toggleGohonzonDelete = (app = null) => {
    setSelectedApplication(app);
    setGohonzonDeleteModel((p) => !p);
  };
  const toggleUpdateExamEntry = (exam = null) => {
    setSelectedExam(exam);
    setUpdateExamEntryModal((p) => !p);
  };

  const onGohonzonEditClick = (app) => {
    console.log("application", app);
    toggleGohonzonUpdate(app);
  };
  const onGohonzonDeleteClick = (app) => {
    console.log("applicationsss", app);
    toggleGohonzonDelete(app);
  };
  const onEditClick = (exam) => toggleUpdateExamEntry(exam);

  const onDeleteClick = async () => {
    try {
      const payload = {
        examDate: selectedMember.examDate,
        examLevel: selectedMember.examLevel?.toUpperCase(),
        rollNumber: selectedMember.rollNumber,
        remark: selectedMember.remark,
      };
      await Member.removeExam({
        // applicationId: selectedMember.applicationId,
        applicationId: selectedMember.examId || selectedMember.applicationId,
        // memberId: selectedMember.memberId,
        memberId: selectedMember.memberId || memberId,
        data: payload,
      });
      toast.show(`Entry Removed Successfully`, AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const handleDeleteClick = (member) => {
    console.log("kkkerrrr", member);
    setSelectedMember(member);
    setOpenAlert(true);
  };

  const onViewMoreHandler = (tableType, title, sub) => {
    setModalTitle(title);
    setModalSubTitle(sub);
    setSelectedTable(tableType);
    setOpenModal(true);
  };

  const onSelectMember = (member) =>
    navigate(`/${ROUTES.MEMBER_DETAIL.path}/${member.memberId}`);

  const {
    goshoMeeting,
    discussionMeeting,
    NHRMeeting,
    cubMeeting,
    SDMeeting,
    YLMeeting,
    YPMeeting,
  } = attendanceInfo;

  const getMeeting = (type) => {
    if (type === "goshoMeeting") return goshoMeeting;
    if (type === "NHRMeeting") return NHRMeeting;
    if (type === "cubMeeting") return cubMeeting;
    if (type === "SDMeeting") return SDMeeting;
    if (type === "YPMeeting") return YPMeeting;
    if (type === "YLMeeting") return YLMeeting;
    return discussionMeeting;
  };

  return (
    <>
      <Box
        sx={{
          background: BG,
          minHeight: "100vh",
          p: { xs: "12px", md: "1px 20px 10px 20px" },
          boxSizing: "border-box",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "6px",
            flexDirection: { xs: "column", md: "row" },
            mb: "14px",
            alignItems: "stretch",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "6px",
              flex: "0 0 auto",
              width: { xs: "100%", md: "385px" },
            }}
          >
            <Card
              title="Examination Details"
              subtitle={`${examMemberInfo?.length || 0} Examinations Completed`}
              headerRight={
                canManageCrud ? (
                  <Pill
                    label="+ Add"
                    onClick={() => setDirectExamEntryModal(true)}
                  />
                ) : null
              }
            >
              <DirectExamEntryModal
                open={directExamEntryModal}
                onClose={() => setDirectExamEntryModal(false)}
                application={memberInfo}
                onRefresh={onRefresh}
              />

              <ExamIconList
                data={examMemberInfo}
                hasPermission={hasPermission}
                onDelete={handleDeleteClick}
                onEdit={onEditClick}
                canManageCrud={canManageCrud}
              />
            </Card>

            <Card
              title="Subscription Details"
              headerRight={
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  {subscriptionMemberInfo?.length > 3 && (
                    <Pill
                      label="View More"
                      onClick={() =>
                        onViewMoreHandler(
                          TABLE_TYPE.SUBS,
                          "Subscription Details",
                          "Subscription Details"
                        )
                      }
                    />
                  )}

                  {canManageCrud ? (
                    <Pill
                      label="Edit"
                      onClick={() => setEditSubscription(true)}
                    />
                  ) : null}
                </Box>
              }
            >
              <EditSubscription
                open={editSubscription}
                onClose={() => setEditSubscription(false)}
                application={memberInfo}
                onRefresh={onRefresh}
              />
              <NewTable
                isSubscription
                columns={SUBSCRIPTION_COL}
                rows={getSubscriptionRows(subscriptionMemberInfo)}
                tableHeadCellStyle={headStyle()}
                tableBodyTheme="#FAFBFE"
              />
            </Card>

            <Card title="Special Group Induction/Graduation">
              <NewTable
                columns={SPECIAL_GROUP_COL}
                rows={getSpecialGroupRows(specialMemberInfo)}
                tableHeadCellStyle={headStyle()}
                tableBodyTheme="#FAFBFE"
              />
            </Card>

            <Box sx={{ flex: "0 0 auto", width: { xs: "100%" } }}>
              <Card title="Remarks" headerRight={<Comment />}>
                {!remark || !remark.length ? (
                  <Box sx={{ textAlign: "center", p: "14px 18px" }}>
                    <Typography
                      style={{
                        color: MUTED,
                        fontSize: "13px",
                        fontWeight: 600,
                      }}
                    >
                      No data available
                    </Typography>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      m: "10px 14px",
                      background: "#F0F4FA",
                      borderRadius: "10px",
                      p: "10px 14px",
                    }}
                  >
                    <Typography
                      style={{
                        color: "#374151",
                        fontSize: "13px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                      }}
                    >
                      {remark}
                    </Typography>
                  </Box>
                )}
              </Card>
            </Box>
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Card
              title="Appointment History"
              subtitle={`${
                (appointmentInfo?.length || 0) +
                (previousAppointmentInfo?.length || 0)
              } Positions`}
              style={{ height: "auto", minHeight: "600px" }}
            >
              <AppointmentTimeline
                current={appointmentInfo}
                previous={previousAppointmentInfo}
                memberInfo={memberInfo}
              />
            </Card>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: "6px",
            flexDirection: { xs: "column", md: "row" },
            mb: "14px",
            alignItems: "stretch",
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Card
              title="Awards"
              headerRight={
                canManageCrud ? (
                  <Pill
                    label="+ Add"
                    color="#7C3AED"
                    bg="#F5F3FF"
                    onClick={() => setAwardsModal(true)}
                  />
                ) : null
              }
            >
              <AwardsModal
                open={awardsModal}
                onClose={() => setAwardsModal(false)}
                application={memberInfo}
                onRefresh={onRefresh}
              />
              <NewTable
                columns={AWARDS_COL}
                rows={getAwardRows(awardMemberInfo)}
                tableHeadCellStyle={headStyle("#F3EEFF", "#5B3F8A")}
                tableBodyTheme="#FAFBFE"
              />
            </Card>
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Card
              title="Gohonzon Details"
              headerRight={
                canManageCrud ? (
                  <Pill
                    label="+ Add"
                    color="#0369A1"
                    onClick={() => setDirectEntryModal(true)}
                  />
                ) : null
              }
            >
              <DirectEntryModal
                open={directEntryModal}
                onClose={() => setDirectEntryModal(false)}
                application={memberInfo}
                onRefresh={onRefresh}
              />
              <NewTable
                columns={GOHONZON_COL}
                rows={getGohonzonMemberRows(
                  gohonzonMemberInfo,
                  hasPermission,
                  canManageCrud,
                  canManageCrud,
                  onGohonzonEditClick,
                  onGohonzonDeleteClick
                )}
                tableHeadCellStyle={headStyle("#EDF6FF", "#1D4ED8")}
                tableBodyTheme="#FAFBFE"
              />
            </Card>
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Card title="Honorary District Chief">
              <NewTable
                columns={HDC_COL}
                rows={getHdcRows(hdcInfo)}
                tableHeadCellStyle={headStyle("#ECFDF5", "#059669")}
                tableBodyTheme="#FAFBFE"
              />
            </Card>
          </Box>
        </Box>

        <Box
          sx={{
            background: WHITE,
            borderRadius: RADIUS,
            boxShadow: SHADOW,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              px: "20px",
              pt: "16px",
              pb: "12px",
              borderBottom: `1px solid ${BORDER}`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                style={{ fontSize: "16px", fontWeight: 700, color: TITLE }}
              >
                Meetings Attended{" "}
                <span style={{ fontWeight: 500 }}>(Last 12 months)</span>
              </Typography>
            </Box>
            {getMaxRow(attendanceInfo) > ROW_LIMIT.ATTENDANCE && (
              <Pill
                label="View All"
                onClick={() =>
                  onViewMoreHandler(
                    TABLE_TYPE.ATTENDANCE,
                    "Attendance",
                    "Attendance"
                  )
                }
              />
            )}
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "6px",
              px: "16px",
              py: "12px",
              background: "#F8FAFD",
              borderBottom: `1px solid ${BORDER}`,
              flexWrap: "wrap",
            }}
          >
            {[
              [meetingType, setMeetingType],
              [meetingType1, setMeetingType1],
              [meetingType2, setMeetingType2],
            ].map(([val, setter], i) => (
              <Box key={i} sx={{ flex: "1 1 180px", minWidth: "140px" }}>
                <Dropdown
                  label="Select Meeting Type"
                  name={val}
                  options={MEETING_TYPE}
                  value={val}
                  onChange={(e) => setter(e.target.value)}
                />
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "6px",
              p: "16px",
              flexWrap: { xs: "wrap", md: "nowrap" },
            }}
          >
            <MeetingPanel meeting={getMeeting(meetingType)} />
            <MeetingPanel meeting={getMeeting(meetingType1)} />
            <MeetingPanel meeting={getMeeting(meetingType2)} />
          </Box>
        </Box>
      </Box>

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        customStyle={{
          maxHeight: "95%",
          minWidth: { xs: "95%", md: "40%" },
          maxWidth: "98%",
          overflowY: "auto",
          margin: "auto",
          borderRadius: RADIUS,
        }}
      >
        <ModalContent
          memberId={memberId}
          modalTitle={modalTitle}
          subTitle={modalSubTitle}
          selectedTable={selectedTable}
          meetingType={meetingType}
          meetingType1={meetingType1}
          meetingType2={meetingType2}
          onRefresh={onRefresh}
          onClose={() => setOpenModal(false)}
          canManageCrud={canManageCrud}
        />
      </Modal>

      <UpdateDirectExamEntryModal
        open={updateExamEntryModal}
        onClose={() => toggleUpdateExamEntry()}
        exam={selectedExam}
        onRefresh={onRefresh}
      />
      <Alert
        open={openAlert}
        onClose={() => setOpenAlert(false)}
        onSubmit={onDeleteClick}
        selectedMember={selectedMember}
      />
      <GohonzonUpdateModal
        open={gohonzonUpdateModal}
        onClose={() => toggleGohonzonUpdate()}
        application={application}
        onRefresh={onRefresh}
      />
      <GohonzonDeleteModel
        open={gohonzonDeleteModal}
        onClose={() => toggleGohonzonDelete()}
        application={application}
        onRefresh={onRefresh}
      />
    </>
  );
}

export default Dashboard;
